import fetch from './httpFetch.js'
import Cookies from 'js-cookie'
import secret from '../secret/secret.js'


export function reLogin(username, password) {
  let data = {
    username,
    password
  }
  return fetch.get('/reLogin', data)
}
export function login(userName, password, verifyCode,verifyCodeId) {
  let data = {
    userName,
    password,
    verifyCode,
    verifyCodeId
  }
  
  return fetch.post('/user/login', data)
}


function convertTreeData(rows, attributes) {
  var keyNodes = {}, parentKeyNodes = {};
  for (var i = 0; i < rows.length; i++) {
    var row = rows[i];
    row.id = row[attributes.id];
    row.parentId = row[attributes.parentId];
    row.title = row[attributes.title] ? row[attributes.title] : null
    row.url = row[attributes.url] ? row[attributes.url] : null
    row.icon = row[attributes.icon] ? row[attributes.url] : null
    row.children = [];

    keyNodes[row.id] = row;

    if (parentKeyNodes[row.parentId]) { parentKeyNodes[row.parentId].push(row); }
    else { parentKeyNodes[row.parentId] = [row]; }

    var children = parentKeyNodes[row.id];
    if (children) { row.children = children; }

    var pNode = keyNodes[row.parentId];
    if (pNode) { pNode.children.push(row); }
  }
  return parentKeyNodes[attributes.rootParentId];
}

export function getMenuList(token) {
  // return fetch.get("/getMenuList")
  return new Promise((resolve, reject) => {
    fetch.get('/getMenuListSimp').then(res => {


      if (res && res.data.length > 0) {
        const data = convertTreeData(res.data, {
          id: 'menu_id',
          title: 'menu_name',
          parentId: 'menu_parent_id',
          icon: 'menu_icon',
          url: 'menu_url',
          rootParentId: 'BIZFRAME'
        })
        resolve({ 'data': data })
      }
    })
  })
}

export function changePwd(old_password, new_password) {
  // let sessionId = sessionStorage['token']
  return new Promise((resolve, reject) => {
    let data = {
      userId: sessionStorage['userId'],
      oldPassword: secret.encryptDES(old_password) ,
      newPassword: secret.encryptDES(new_password)
    }
    resolve(fetch.post('/user/mod-pwd', data))
  })
}

export function logout(token) {
  return fetch.get("/user/logout?token="+token)
}

export function register(data) {
 return fetch.post("/user/register", data)
}

export function GetVerifyCode(uri){
  return fetch.get(uri + (new Date()).getTime())
}



// WEBPACK FOOTER //
// ./src/api/login.js